export const HALLAZGO_NO_VALIDADO = {
  value: 2,
  label: 'No validado'
};
export const HALLAZGO_CANCELADO = {
  value: 3,
  label: 'Cancelado'
};
export const HALLAZGO_VALIDADO = {
  value: 4,
  label: 'Validado'
};
